module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAOCAYAAAAbvf3sAAAAAXNSR0IArs4c6QAAAHdJREFUKBXNTkEOgCAMQ97B+/nBeJI33zBbwoTgJHpzSbOmpWUhDKOqCcjA3kCehied0gAOYB5q9xBEtnEKwDBBzsm9ujGIPINztZFXBZ4XqN5stICaHo283RENwhYLWKPtSZdtfGzman8/adXmeT/9oXi3PmhyAqy3mq8fDSDoAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon--padlock.png
// module id = +y3U
// module chunks = 1